export default __webpack_public_path__ + "static/media/hamburger.e97ffed9.svg";